// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"781e157d","227":"4b7123b7","275":"7a00e0b4","285":"da0eb3e1","453":"13bc135d","553":"86f34dbf","716":"b6446f90","760":"85dd9bf3","976":"839d6db5","977":"29362626"}[chunkId] + ".chunk.js";
};